import { trackLastTransactionsAmplitudeEvent } from '@/modules/transaction/helpers/track-amplitude-event';
import { WarrenModules } from '@/types/navigation';
import { EventProperties } from '@warrenbrasil/web-analytics';

const transactionEventMap: { [module in WarrenModules]?: EventProperties } = {
  [WarrenModules.Cash]: {
    name: 'click_account',
    target: 'Conta'
  },
  [WarrenModules.Wealth]: {
    name: 'click_wallet',
    target: 'Carteira'
  },
  [WarrenModules.Trade]: {
    name: 'click_broker',
    target: 'Bolsa'
  }
};

export function trackPageLoad() {
  trackLastTransactionsAmplitudeEvent({
    event_type: 'Load',
    event_name: 'view'
  });
}

export function trackPageBackClick() {
  trackLastTransactionsAmplitudeEvent({
    event_type: 'Click',
    event_name: 'back',
    page_screen_section: 'header'
  });
}

export function trackChangeTabClick(module: Partial<WarrenModules>) {
  trackLastTransactionsAmplitudeEvent({
    event_type: 'Click',
    event_name: transactionEventMap[module]!.name as string,
    page_screen_section: 'body',
    event_target: transactionEventMap[module]!.target
  });
}
